module.exports = __webpack_public_path__ + "img/step-8.83d144da.jpg";